import { render, staticRenderFns } from "./procurementvn.vue?vue&type=template&id=bd32aaaa&scoped=true&"
import script from "./procurementvn.vue?vue&type=script&lang=js&"
export * from "./procurementvn.vue?vue&type=script&lang=js&"
import style0 from "./procurementvn.vue?vue&type=style&index=0&id=bd32aaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd32aaaa",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
